module.exports = __webpack_public_path__ + "img/map-cgj.f99b3761.png";